module.exports = __webpack_public_path__ + "static/media/GG_H_03.d2f760bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/heads/GG_H_03.png
// module id = 132
// module chunks = 0